import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import EnvProvider from 'jvjr-docker-env';

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        mpfapi_token: localStorage.getItem('mpfapi_token') || null,
        api_token: localStorage.getItem('api_token') || null,
        is_login: localStorage.getItem('is_login') || null,
        agente: JSON.parse(localStorage.getItem('agente')) || null
    },
    getters: {
        isLoggedIn(state) {
            return state.is_login !== null
        },
        getMpfApiToken(state) {
            return state.mpfapi_token ? state.mpfapi_token : null
        },
        logUser(state) {
            return state.agente ? state.agente : null
        }
    },
    mutations: {
        login(state, is_login) {
            state.is_login = is_login
        },
        MpfApiToken(state, mpfapi_token) {
            state.mpfapi_token = mpfapi_token
        },
        ApiToken(state, api_token) {
            state.api_token = api_token
        },
        Agente(state, agente) {
            state.agente = JSON.parse(agente)
        },
        logout(state) {
            state.api_token = null
            state.is_login = null
            state.agente = null
        }
    },
    actions: {
        login(context, credentials) {
            return new Promise((resolve, reject) => {
                axios.post(EnvProvider.value('FIRMADOR_API_URL') + 'login', {
                    username: credentials.usuario,
                    password: credentials.password
                }, {})
                    .then(function (response) {
                        if (response.data.user && response.data.user.api_token) {
                            let is_login = (response.data.status == "ok");
                            localStorage.setItem('api_token', response.data.user.api_token);
                            context.commit('ApiToken', response.data.user.api_token);
                            localStorage.setItem('agente', JSON.stringify(response.data.user));
                            context.commit('Agente', JSON.stringify(response.data.user));
                            localStorage.setItem('is_login', is_login);
                            context.commit('login', is_login);
                        }
                        resolve(response);
                    }).catch(errorFirmadorApi => {
                        reject(errorFirmadorApi)
                    });
            });
        },
        captcha(context, recaptchaToken) {
            return new Promise((resolve, reject) => {
                axios.post("https://www.google.com/recaptcha/api/siteverify", {
                    secret: EnvProvider.value('CAPTCHA_SECRET_KEY'),
                    response: recaptchaToken
                }).then(response => {
                    resolve(response.data.message);
                }).catch(err => {
                    self.serverError = getErrorMessage(err);
                    function getErrorMessage(err) {
                        let responseBody;
                        responseBody = err.response;
                        if (!responseBody) {
                            responseBody = err;
                        } else {
                            responseBody = err.response.data || responseBody;
                        }
                        reject(responseBody.message || JSON.stringify(responseBody));
                    }
                });
            })
        },
        getFilesToSign() {
            return new Promise((resolve, reject) => {
                axios.get(EnvProvider.value('FIRMADOR_API_URL') + 'fmng/list', { headers: { 'Authorization': this.state.api_token } }).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getFilesToDownload() {
            return new Promise((resolve, reject) => {
                axios.get(EnvProvider.value('FIRMADOR_API_URL') + 'fmng/list/true', { headers: { 'Authorization': this.state.api_token } }).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        validarPin(context, cert_pass) {
            return new Promise((resolve, reject) => {
                axios.post(EnvProvider.value('FIRMADOR_API_URL') + 'validarPinCertDigital', {
                    use_code: this.state.agente.id,
                    cert_pass: cert_pass.cert_pass
                }, { headers: { 'Authorization': this.state.api_token } }).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        signFiles(context, vars) {
            return new Promise((resolve, reject) => {
                axios.post(EnvProvider.value('FIRMADOR_API_URL') + 'fmng/sign', {
                    files: vars.files,
                    cert_pass: vars.cert_pass
                }, { headers: { 'Authorization': this.state.api_token } }).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        downloadFiles(context, filesToDownload) {
            return new Promise((resolve, reject) => {
                axios.post(EnvProvider.value('FIRMADOR_API_URL') + 'fmng/download', {
                    username: this.state.agente.usuario,
                    files: filesToDownload.files
                }, { headers: { 'Authorization': this.state.api_token }, responseType: 'blob' }).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        deleteFile(context, params) {
            return new Promise((resolve, reject) => {
                axios.post(EnvProvider.value('FIRMADOR_API_URL') + 'fmng/delete', {
                    username: this.state.agente.usuario,
                    file: params.file,
                    signed: params.signed
                }, { headers: { 'Authorization': this.state.api_token } }).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        logout(context) {
            if (context.getters.isLoggedIn) {
                localStorage.removeItem('is_login')
                localStorage.removeItem('mpfapi_token')
                localStorage.removeItem('api_token')
                localStorage.removeItem('agente')
                context.commit('logout')
            }
        }
    }
})